import { createStore } from 'effector';

import { type AdditionalProductNames } from 'types/zod/additional-products';

export const $additionalProducts = createStore<Record<AdditionalProductNames, boolean>>({
    giftTrust: false,
});
